module.exports = __webpack_public_path__ + "img/lectofilo.d7ecdf5b.png";